import { LoadingDots } from '@carboncopyco/ui';
import classNames from 'classnames';
import type React from 'react';
import { ImageInputBox, type ImageInputBoxProps } from './ImageInputBox';

export type DropdzoneState = 'idle' | 'error' | 'loading';

export interface ImageSelectionBoxProps
  extends Pick<ImageInputBoxProps, 'autoFocus' | 'disableFocus' | 'onFocus'> {
  state?: DropdzoneState;
  hoverable?: boolean;
  children?: React.ReactNode;
}

export const ImageSelectionBox = ({
  state = 'idle',
  hoverable,
  children,
  autoFocus,
  disableFocus,
  onFocus,
}: ImageSelectionBoxProps) => {
  return (
    <ImageInputBox
      hoverable={hoverable}
      autoFocus={autoFocus}
      disableFocus={disableFocus}
      onFocus={onFocus}
    >
      <div
        className={classNames(
          'w-full h-ds-30 flex justify-center items-center rounded-ds-md border',
          hoverable && 'hover:bg-ds-natural-100',
          state === 'error'
            ? 'border-ds-danger-300'
            : 'border-dashed border-ds-natural-150'
        )}
      >
        {state === 'loading' ? (
          <LoadingDots />
        ) : (
          <div className="flex flex-col items-center gap-1 px-8">
            {children}
          </div>
        )}
      </div>
    </ImageInputBox>
  );
};
